import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { CapabilityType } from '../models/capability-type';
import { RolesService } from '../services/roles.service';
import { PlanogramService } from '../services/planogram.service';
import { CapabilitiesService } from '../services/capabilities.service';

@Directive({ selector: '[hasCapability]' })
export class HasCapabilityDirective implements OnInit, OnDestroy {
  private subscription: Subscription | null = null;
  private _capabilities: CapabilityType[] = [];

  @Input() set hasCapability(capabilities: CapabilityType | CapabilityType[]) {
    // Normalize to array
    this._capabilities = Array.isArray(capabilities) ? capabilities : [capabilities];
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private planogramService: PlanogramService,
    private rolesService: RolesService,
    private capabilitiesService: CapabilitiesService
  ) {}

  ngOnInit(): void {
    // Reactive: Update on changes to roles or planogram status (which affects shareType)
    this.subscription = combineLatest([
      this.rolesService.roles,
      this.planogramService.status$
    ]).subscribe(() => {
      this.updateView();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private updateView(): void {
    if (!this._capabilities?.length) return;

    const hasCap = this._capabilities.some(c => this.capabilitiesService.hasCapability(c));

    if (hasCap) {
      if (this.viewContainer.length === 0) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    } else {
      this.viewContainer.clear();
    }
  }
}